import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MarketButton } from '@market/react';
import { BASE_THEME } from 'theme/shop_theme';
import { shopImageSrcSet } from 'utilities/images';
import { toCurrencyWithMinorUnitAmount } from 'utilities/currency';
import { localizedShopPath } from 'utilities/locales';
import { isDashboardMode } from 'helpers/search_parameter_helpers';

const AddToCartButton = (props) => {
  const { t } = useTranslation();

  const { id, disabled, size, activeItemId, onClick } = props;

  return (
    <MarketButton
      {...(disabled && id === activeItemId && { disabled: true })}
      id={id}
      rank="primary"
      onClick={onClick}
      size={size}
      style={{ width: '100%' }}
    >
      {t('productPage.addToCart')}
    </MarketButton>
  );
};

const RecommendedProductCard = (props) => {
  const {
    id,
    slug = null,
    title = null,
    img = null,
    price = null,
    currency = null,
    requesting,
    activeItemId,
    onAddToCartClick,
    trackViewEvent,
    trackingEventTypes,
  } = props;

  if (!slug || !title || !img || !price || !currency) {
    return null;
  }

  const itemLink = `${localizedShopPath()}/products/${slug}`;

  const trackViewPdp = () =>
    trackViewEvent({
      eventName: trackingEventTypes.ViewPdp,
      slug,
      name: title,
      id,
      eventDescription: 'View PDP',
    });

  const productImg = (
    <img
      alt={title}
      srcSet={shopImageSrcSet({
        baseUrl: img,
        type: 'cartProductTile',
        fm: 'png',
      })}
      width="110px"
      height="110px"
    />
  );

  return (
    <Grid container item xs={12} md={6}>
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{
          backgroundColor: BASE_THEME.color.gray['5'],
          borderRadius: '10px',
          height: 'fit-content',
        }}
        spacing={1}
        p={1}
      >
        <Grid container item xs={11} md={8.5} alignItems="center">
          <Grid item xs={5} sm={3} md={5} lg={4}>
            {isDashboardMode() ? (
              productImg
            ) : (
              <a href={itemLink} onClick={trackViewPdp}>
                {productImg}
              </a>
            )}
          </Grid>

          <Grid item xs={7} sm={9} md={7} lg={8}>
            <p className="medium-30">{title}</p>
            <p>{toCurrencyWithMinorUnitAmount(price, currency)}</p>
          </Grid>
        </Grid>

        <Grid item xs={12} md={3.5} p={1}>
          <AddToCartButton
            id={id}
            disabled={requesting}
            size="small"
            onClick={onAddToCartClick}
            activeItemId={activeItemId}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default RecommendedProductCard;
